import React from 'react'

function Catalogue() {
  return (
    <div>Catalogue</div>
  )
}

export default Catalogue